export default "__VITE_ASSET__4aaec31e__"